function zodToMongooseSchema(zodSchema) {
  const shape = zodSchema._def.shape();
  const mongooseFields = {};

  Object.keys(shape).forEach(key => {
    const fieldDef = shape[key];
    let innerType = fieldDef;
    let isRequired = true;

    if (fieldDef._def.typeName === 'ZodOptional') {
      innerType = fieldDef._def.innerType;
      isRequired = false;
    }

    const typeName = innerType._def.typeName;

    if (typeName === 'ZodUnion') {
      mongooseFields[key] = String;
    } else if (typeName === 'ZodString') {
      mongooseFields[key] = isRequired ? { type: String, required: true } : String;
    } else if (typeName === 'ZodArray') {
      mongooseFields[key] = [String];
    }
  });

  return mongooseFields;
}

module.exports = { zodToMongooseSchema };
